export default class Helpers {
	getImageLightness(imageSrc) {
		return new Promise((resolve, reject) => {
			let img = document.createElement('img');
			img.src = imageSrc;
			img.style.display = 'none';
			document.body.appendChild(img);

			let colorSum = 0;

			img.onload = function() {
				// create canvas
				let canvas = document.createElement('canvas');
				canvas.width = this.width;
				canvas.height = this.height;

				let ctx = canvas.getContext('2d');
				ctx.drawImage(this, 0, 0);

				let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
				let data = imageData.data;
				let r, g, b, avg;

				for (let x = 0, len = data.length; x < len; x += 4) {
					r = data[x];
					g = data[x + 1];
					b = data[x + 2];

					avg = Math.floor((r + g + b) / 3);
					colorSum += avg;
				}

				let brightness = Math.floor(colorSum / (this.width * this.height));
				resolve(brightness);
			};
		});
	}
}
